import { useCallback } from "react";
import {
  ApiResponseDTODocumentStatusResponseDTO,
  DocumentApiService,
} from "@zenith/services/user";
import createPollingHook from "@zenith/utils/Helpers/createPollingHook";

/**
 * Creates a wrapper function for document verification polling using our utility
 */
export default function useDocumentVerification(
  isPollingActive: boolean,
  isProcessing: boolean,
  jobId: string,
  enabled = true
) {
  const fetchData = useCallback(
    () => DocumentApiService.getDocumentStatus(jobId),
    [jobId]
  );

  // Create a custom hook with our specific fetch function
  const CustomHook = createPollingHook<
    ApiResponseDTODocumentStatusResponseDTO,
    string
  >({
    pollingType: "document-verification",
    fetchFunction: fetchData,
    getStatus: (response) => response.data?.status || "",
    terminalStatuses: ["VERIFIED_SUCCESSFULLY", "ERROR_IN_VERIFICATION", "NEEDS_MANUAL_VERIFICATION"],
    defaultPollingConfig: {
      interval: 3000,
      maxRetries: 100,
      maxPollingTime: 300000, // 5 minutes
    },
  });

  return CustomHook(isPollingActive, isProcessing, jobId, enabled);
}
